import { render, staticRenderFns } from "./PolicyItemBen.vue?vue&type=template&id=9af42c8e&"
import script from "./PolicyItemBen.vue?vue&type=script&lang=js&"
export * from "./PolicyItemBen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports